let lastScrollTop = 0;

// Function to handle scroll event
function handleScroll() {
  const topNav = document.getElementById("top-navigation");
  if (!topNav) return; // Exit if element not found

  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > lastScrollTop) {
    // Scrolling down
    topNav.classList.add("hidden-top-nav");
  } else {
    // Scrolling up
    topNav.classList.remove("hidden-top-nav");
  }

  if (document.getElementById("header-scroll-logo") != null) {
    showHeaderLogo(scrollTop === 0 ? false : true);
  }

  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
}

function showHeaderLogo(showScrollLogo) {
  const headerStaticLogo = document.getElementById("header-static-logo");
  const headerScrollLogo = document.getElementById("header-scroll-logo");

  if (showScrollLogo) {
    // When true we're scrolling
    if (headerStaticLogo != null) {
      headerStaticLogo.classList.add("hidden");
    }
    if (headerScrollLogo != null) {
      headerScrollLogo.classList.remove("hidden");
    }
  } else {
    if (headerStaticLogo != null) {
      headerStaticLogo.classList.remove("hidden");
    }
    if (headerScrollLogo != null) {
      headerScrollLogo.classList.add("hidden");
    }
  }
}

function toggleNavigationSearch() {
  const searchNavigationWrapper = document.getElementById("search-navigation");
  if (searchNavigationWrapper != null || searchNavigationWrapper != undefined) {
    searchNavigationWrapper.classList.toggle("hidden");
    document.querySelector("body").classList.toggle("overflow-hidden");
  }
}

// Attach the scroll event listener
window.addEventListener("scroll", handleScroll);
